import { Component, OnInit } from '@angular/core';
import { MessageBoxIcon, ModalRef } from '@app/core/models/modal-ref';

@Component({
  selector: 'app-message-box-content',
  templateUrl: './message-box-content.component.html',
  styleUrls: ['./message-box-content.component.scss']
})
export class MessageBoxContentComponent implements OnInit {
  public MessageBoxIcon = MessageBoxIcon;

  public svgIcon = '';
  public faIcon: [string, string] = ['', ''];
  public iconClass = '';

  constructor(public modalRef: ModalRef, public data: MessageBoxData) { }

  ngOnInit(): void {
    switch (this.data.icon) {
      case MessageBoxIcon.Information:
        this.svgIcon = 'info-circle';
        this.faIcon = ['fas', 'info-circle'];
        this.iconClass = 'messagebox-icon-blue';
        break;
      case MessageBoxIcon.Question:
        this.svgIcon = 'question-circle';
        this.faIcon = ['fas', 'question-circle'];
        this.iconClass = 'messagebox-icon-blue';
        break;
      case MessageBoxIcon.Warning:
        this.svgIcon = 'exclamation-triangle';
        this.faIcon = ['fas', 'exclamation-triangle'];
        this.iconClass = 'messagebox-icon-yellow';
        break;
      case MessageBoxIcon.Error:
        this.svgIcon = 'times-circle';
        this.faIcon = ['fas', 'times-circle'];
        this.iconClass = 'messagebox-icon-red';
        break;
    }
  }

}

export class MessageBoxData {
  public text = '';
  public icon: MessageBoxIcon = MessageBoxIcon.None;
}
